import type { PropsWithChildren } from 'react'
import { cx } from 'src/utils/cx'

export function ContentFittableBox(
  props: PropsWithChildren &
    StyleProps & {
      ratio: number
      maxWidth?: number
      maxHeight?: number
      alignment?:
        | 'top'
        | 'bottom'
        | 'left'
        | 'right'
        | 'center'
        | 'top-left'
        | 'top-right'
        | 'bottom-left'
        | 'bottom-right'
      static?: boolean
    },
) {
  const alignment = props.alignment?.split('-') ?? ['center']
  if (alignment.length < 2) alignment.push('center')
  const alignmentClassName = alignment
    .map(
      s =>
        ({
          top: 'mt-0',
          bottom: 'mb-0',
          left: 'ml-0',
          right: 'mr-0',
        })[s],
    )
    .join(' ')

  return (
    <div className={cx('relative', props.className)} style={{ ...props.style }}>
      <div
        className={cx(
          !props.static && 'absolute inset-0',
          'm-auto',
          alignmentClassName,
        )}
        style={{
          aspectRatio: props.ratio,
          maxWidth: `min(100%, ${
            props.maxWidth ? props.maxWidth + 'px' : '100%'
          })`,
          maxHeight: `min(100%, ${
            props.maxHeight ? props.maxHeight + 'px' : '100%'
          })`,
        }}
      >
        {props.children}
      </div>
    </div>
  )
}
